import {DialogDismiss, DialogHeader, DialogHeading} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useAgendaAppointmentEventData} from '@/features/agenda/hooks/useAgendaAppointmentEventData'
import {AgendaEventType} from '@/features/agenda/types'
import {useTranslation} from 'react-i18next'
import {StyledDot, StyledEventDetailsHeaderTitle} from './style'
import {AgendaEventSectorIcon} from '@/features/agenda/components/agenda-event-sector-icon/AgendaEventSectorIcon'

export const AgendaEventDetailsDialogHeader = ({
    agendaEvent,
    isARecovery
}: {
    agendaEvent: AgendaEventType
    isARecovery: boolean
}) => {
    const {accessTypes} = useAgendaAppointmentEventData({
        agendaEvent: agendaEvent.type == 'event' ? agendaEvent : null
    })
    const {t} = useTranslation()

    return (
        <DialogHeader>
            <DialogHeading>
                <Flexbox gap={2} align="center">
                    <StyledEventDetailsHeaderTitle gap={2} align="center">
                        <AgendaEventSectorIcon sector={agendaEvent.sector} size={18} />
                        <span>{accessTypes}</span>
                    </StyledEventDetailsHeaderTitle>
                    {isARecovery && (
                        <Flexbox align="center" gap={2}>
                            <StyledDot />
                            {t('agenda:missed_access_title')}
                        </Flexbox>
                    )}
                </Flexbox>
            </DialogHeading>
            <DialogDismiss />
        </DialogHeader>
    )
}
